"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaSourceOrigin = exports.FILE_NAME_SHORT_NAME_SEPARATOR = exports.FILE_NAME_LAST_SUBSTRING_LENGTH = exports.FILE_NAME_FIRST_SUBSTRING_LENGTH = exports.FILE_NAME_MAX_LENGTH = exports.SUPPORTED_IMAGE_EXTENSIONS = exports.SUPPORTED_DOCUMENT_EXTENSIONS = exports.SUPPORTED_VIDEO_EXTENSIONS = exports.SUPPORTED_AUDIO_EXTENSIONS = exports.AUDIO_BLOCK_TYPES = exports.MEDIA_LIBRARY_COMPONENTS_TYPE = exports.MEDIA_TYPES = exports.MODEL_EVENTS = exports.UPLOAD_STATUSES = exports.FRAGMENTS_NAMES = void 0;
exports.default = {
    comments: {
        context: {
            types: {
                course: 'course',
                section: 'section',
                question: 'question',
                informationContent: 'informationContent'
            },
            properties: {
                title: 'title',
                introduction: 'introduction',
                voiceOver: 'voiceOver',
                learningContent: 'learningContent'
            }
        }
    }
};
var FRAGMENTS_NAMES;
(function (FRAGMENTS_NAMES) {
    FRAGMENTS_NAMES["notification"] = "notification";
    FRAGMENTS_NAMES["editorShell"] = "editor-shell";
    FRAGMENTS_NAMES["materialList"] = "material-list";
    FRAGMENTS_NAMES["materialEditor"] = "material-editor";
    FRAGMENTS_NAMES["collaboration"] = "collaboration";
    FRAGMENTS_NAMES["review"] = "review";
    FRAGMENTS_NAMES["contentEditor"] = "content-editor";
    FRAGMENTS_NAMES["configurationSettings"] = "configuration-settings";
    FRAGMENTS_NAMES["publish"] = "publish";
    FRAGMENTS_NAMES["materialResults"] = "material-results";
    FRAGMENTS_NAMES["preview"] = "preview";
    FRAGMENTS_NAMES["organization"] = "organization";
    FRAGMENTS_NAMES["accountSettings"] = "account-settings";
    FRAGMENTS_NAMES["questionEditor"] = "question-editor";
    FRAGMENTS_NAMES["mediaLibrary"] = "media-library";
    FRAGMENTS_NAMES["homePage"] = "home-page";
})(FRAGMENTS_NAMES || (exports.FRAGMENTS_NAMES = FRAGMENTS_NAMES = {}));
var UPLOAD_STATUSES;
(function (UPLOAD_STATUSES) {
    UPLOAD_STATUSES["LOADED"] = "loaded";
    UPLOAD_STATUSES["FAILED"] = "failed";
    UPLOAD_STATUSES["INPROGRESS"] = "inProgress";
})(UPLOAD_STATUSES || (exports.UPLOAD_STATUSES = UPLOAD_STATUSES = {}));
var MODEL_EVENTS;
(function (MODEL_EVENTS) {
    MODEL_EVENTS["loaded"] = "loaded";
    MODEL_EVENTS["failed"] = "failed";
    MODEL_EVENTS["progressed"] = "progressed";
})(MODEL_EVENTS || (exports.MODEL_EVENTS = MODEL_EVENTS = {}));
var MEDIA_TYPES;
(function (MEDIA_TYPES) {
    MEDIA_TYPES["audio"] = "audio";
    MEDIA_TYPES["video"] = "video";
    MEDIA_TYPES["documents"] = "documents";
    MEDIA_TYPES["images"] = "images";
})(MEDIA_TYPES || (exports.MEDIA_TYPES = MEDIA_TYPES = {}));
var MEDIA_LIBRARY_COMPONENTS_TYPE;
(function (MEDIA_LIBRARY_COMPONENTS_TYPE) {
    MEDIA_LIBRARY_COMPONENTS_TYPE["audioLibraryPage"] = "AudioLibraryPage";
    MEDIA_LIBRARY_COMPONENTS_TYPE["videoLibraryPage"] = "VideoLibraryPage";
    MEDIA_LIBRARY_COMPONENTS_TYPE["imageLibraryPage"] = "ImageLibraryPage";
    MEDIA_LIBRARY_COMPONENTS_TYPE["documentsLibraryPage"] = "DocumentsLibraryPage";
    MEDIA_LIBRARY_COMPONENTS_TYPE["imageStockLibrary"] = "ImageStockLibrary";
})(MEDIA_LIBRARY_COMPONENTS_TYPE || (exports.MEDIA_LIBRARY_COMPONENTS_TYPE = MEDIA_LIBRARY_COMPONENTS_TYPE = {}));
var AUDIO_BLOCK_TYPES;
(function (AUDIO_BLOCK_TYPES) {
    AUDIO_BLOCK_TYPES["voiceOver"] = "VoiceOver";
    AUDIO_BLOCK_TYPES["singleAudio"] = "SingleAudio";
})(AUDIO_BLOCK_TYPES || (exports.AUDIO_BLOCK_TYPES = AUDIO_BLOCK_TYPES = {}));
exports.SUPPORTED_AUDIO_EXTENSIONS = [
    '.m4a',
    '.webm',
    '.mp3',
    '.aac',
    '.wma',
    '.wav',
    '.wmv',
    '.ts',
    '.ogg',
    '.au',
    '.aif',
    '.vob',
    '.m4v',
    '.mkv',
    '.mov',
    '.avi',
    '.mp4'
];
exports.SUPPORTED_VIDEO_EXTENSIONS = [
    '.vob',
    '.webm',
    '.mpeg',
    '.mpg',
    '.mp4',
    '.flv',
    '.wmv',
    '.m4v',
    '.mov',
    '.mkv',
    '.mts',
    '.avi'
];
exports.SUPPORTED_DOCUMENT_EXTENSIONS = ['.zip', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'];
exports.SUPPORTED_IMAGE_EXTENSIONS = ['.gif', '.jpg', '.jpe', '.jpeg', '.png', '.bmp', '.webp'];
exports.FILE_NAME_MAX_LENGTH = 40;
exports.FILE_NAME_FIRST_SUBSTRING_LENGTH = 30;
exports.FILE_NAME_LAST_SUBSTRING_LENGTH = 10;
exports.FILE_NAME_SHORT_NAME_SEPARATOR = '...';
var MediaSourceOrigin;
(function (MediaSourceOrigin) {
    MediaSourceOrigin["upload"] = "upload";
    MediaSourceOrigin["recording"] = "recording";
    MediaSourceOrigin["textToSpeech"] = "text-to-speech";
})(MediaSourceOrigin || (exports.MediaSourceOrigin = MediaSourceOrigin = {}));
